import React, { Fragment } from "react";
import { RotatingLines } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import "../components/css/style.css";
import "../components/css/popup.css";

const rootColor = "#fff";

export const xAuth = "M@#weh@##dhASD2627@#2024";
export const flag = "mz";
export const countryCode = "258";
export const baseUrl = "https://vmz.quizzzmaster.com/quizMasterApis";
//export const baseUrlPromo = "https://vmz.quizzzmaster.com/test";
export const baseUrlPromo = "https://vmz.quizzzmaster.com/api";
//export const baseUrlPromo = "https://vmz.quizzzmaster.com";
// export const baseUrlPromo = "http://localhost:5070";

export const Loader = () => {
  return (
    <div style={{ width: "100px", margin: "auto" }}>
      <RotatingLines
        strokeColor="grey"
        strokeWidth="5"
        animationDuration="0.75"
        width="60"
        visible={true}
      />
    </div>
  );
};
export const getLanguages = () => {
  let languages = [];
  languages = [
    { value: "1", label: "French" },
    { value: "0", label: "English" },
  ];
  return languages;
};
export const Notify = (props) => {
  console.log("props=" + props);
  if (props.message) {
    if (props.type) toast.success(props.message);
    else toast.warning(props.message);
  }

  return <ToastContainer />;
};

export const Random = () => {
  let rnd = Math.floor(Math.random() * 90000) + 10000;
  return rnd + "" + Date.now();
};

export const Popup = () => {
  return (
    <div className="popup-container">
      <div className="popup">
        <div style={{ width: "60px", margin: "auto" }}>
          <RotatingLines
            strokeColor="grey"
            strokeWidth="5"
            animationDuration="0.75"
            width="60"
            visible={true}
          />
        </div>
      </div>
    </div>
  );
};

export const PopupSub = (props) => {
  console.log("sub=" + props.subStatus);
  const { t } = useTranslation();
  return (
    <div className="popup-container">
      <div className="popup1">
        {props.subStatus === 201 ? (
          <>
            <div>
              <h3 className="login-title mb-3 mt-3 text-center">{t("126")}</h3>
              <h3 className="login-title mb-3 mt-3 text-center">{t("128")}</h3>
            </div>
            <div>&nbsp;</div>
            <div className="popupDiv col-12">
              <div className="col-2 text-center">
                <button
                  className="pack-btn btn btn-primary btn-pm-custom-red"
                  onClick={() => props.redirectTo("")}
                >
                  {t("88")}
                </button>
              </div>
              <div className="col-8">&nbsp;</div>
              <div className="col-2 text-center">
                <button
                  className="pack-btn btn btn-primary btn-pm-custom-green"
                  onClick={() => props.handleTopup()}
                >
                  {t("87")}
                </button>
              </div>
            </div>
          </>
        ) : props.subStatus === 203 ? (
          <>
            <div>
              <span>{t("130")}</span>
            </div>
            <div>&nbsp;</div>
            <div className="text-center">
              <button
                className="pack-btn btn btn-primary btn-pm-custom-green btn-width-20"
                onClick={() => props.redirectTo("/updatePack")}
              >
                {t("134")}
              </button>
            </div>
          </>
        ) : (
          <>
            <div>
              <span>
                {props.subStatus === 200
                  ? t("133")
                  : props.subStatus === 202
                    ? t("129")
                    : props.subStatus === 204
                      ? t("132")
                      : props.subStatus === 205
                        ? t("130")
                        : props.subStatus === 0
                          ? t("131")
                          : t(props.subStatus)}
              </span>
            </div>
            <div>&nbsp;</div>
            <div className="text-center">
              <button
                className="pack-btn btn btn-primary btn-pm-custom-green btn-width-20"
                onClick={() =>
                  props.redirectTo(props.location ? props.location : "")
                }
              >
                {t("134")}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: rootColor,
    fontSize: "15px",
    fontWeight: 500,
    color: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "10px",
    border: "none",
    outline: "none",
    margin: "0 auto",
    minHeight: "40px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#000",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#000",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? rootColor : "#fff",
    color: state.isSelected ? "#000" : "#000",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "10px",
    marginTop: "1px",
    backgroundColor: rootColor,
  }),
};
